import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Waves } from 'lucide-react';
import { BRAND_GREEN, BRAND_GOLD } from '../theme/sucronTheme';
import { useSportsLang } from '../contexts/SportsLangContext';

const LABELS = {
  pt: {
    title: 'Esportes',
    subtitle: 'Acompanhe competições, atletas e estatísticas do esporte brasileiro',
    footballTitle: 'Futebol',
    footballDesc: 'Campeonatos, partidas, estatísticas e análises',
    swimmingTitle: 'Natação',
    swimmingDesc: 'Competições, recordes, nadadores e clubes',
    explore: (s) => `Explorar ${s} →`,
  },
  en: {
    title: 'Sports',
    subtitle: 'Follow competitions, athletes and statistics of Brazilian sport',
    footballTitle: 'Football',
    footballDesc: 'Championships, matches, statistics and analysis',
    swimmingTitle: 'Swimming',
    swimmingDesc: 'Competitions, records, swimmers and clubs',
    explore: (s) => `Explore ${s} →`,
  }
};

const EsportesPage = () => {
  const { lang } = useSportsLang();
  const t = LABELS[lang] || LABELS.pt;

  const sports = [
    {
      to: '/futebol',
      icon: Trophy,
      title: t.footballTitle,
      description: t.footballDesc,
      color: 'gray',
      stats: ['10 ligas', '500+ partidas', '1200+ jogadores']
    },
    {
      to: '/natacao',
      icon: Waves,
      title: t.swimmingTitle,
      description: t.swimmingDesc,
      color: 'blue',
      stats: ['50+ eventos', '800+ nadadores', '200+ clubes']
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2" style={{ color: BRAND_GREEN }}>
            {t.title}
          </h1>
          <p className="text-gray-600">
            {t.subtitle}
          </p>
        </div>

        {/* Sports Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {sports.map((sport) => {
            const Icon = sport.icon;
            return (
              <Link
                key={sport.to}
                to={sport.to}
                className="group bg-white rounded-xl border border-gray-200 p-6 hover:shadow-lg transition-all duration-200"
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gray-100 rounded-lg group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-gray-700" />
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-gray-800">
                      {sport.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4">
                      {sport.description}
                    </p>
                    
                    {/* Stats */}
                    <div className="flex flex-wrap gap-3 mb-3">
                      {sport.stats.map((stat, idx) => (
                        <span key={idx} className="text-xs bg-gray-100 px-2 py-1 rounded">
                          {stat}
                        </span>
                      ))}
                    </div>
                    
                    <div className="font-semibold text-sm" style={{ color: BRAND_GREEN }}>
                      {t.explore(sport.title)}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EsportesPage;
